import request from "@/plugins/axios"
//上传汇总任务
let prefix = "eids-invoice/tcs/entTax";

export function obtain(criteria) {
  return request({
    url: prefix + '/obtain',
    method: 'post',
    data: criteria,
  })
}


//获取登录二维码
export function executeTask(nsrsbh) {
  return request({
    url:  'eids-invoice/tcs/login/success2/'+nsrsbh,
    method: 'get',
  })
}